import { useForm } from "react-hook-form";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import CSP_logo from "../assets/img/CSP_logo.png";
import userService from "../services/users-service"

const ForgotPassword = ({ history }) => {
  // react hook form
  const { register, handleSubmit,errors } = useForm({});
  const onSubmit = async (data) => {
    try {
      const resp = await userService.forgotPassword(data.email);      
      if(resp.code===200 || resp.code===204){
        const { hide } = cogoToast.success("Password Link has been sent to your mail,Please check to reset the password ! ", {hideAfter:15,
            onClick: () => {
                hide();
            },
        });

      }else{
          const { hide } = cogoToast.error(resp.msg, {hideAfter:15,
              onClick: () => {
                  hide();
              },
          });
      }
    } catch (e) {
      const { hide } = cogoToast.error("User Not Found!", {hideAfter:15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  return (
    <>
      <div className="p-2 min-h-screen bg-hero-pattern bg-cover bg-no-repeat bg-center">
        <header>
          <img alt=''
            className="w-7/12 md:w-64 mx-auto mt-7 md:ml-16 md:mt-8"
            src={CSP_logo}
          />
        </header>
        <div
          className="w-5/6 md:w-1/3 m-auto bg-white rounded mt-14 mb-14 p-5 pt-10 pb-10 shadow-loginshadow
      border-borderclr"
        >
          <p className="text-grey_color text-center mb-6 font-bold">
            FORGOT PASSWORD ?
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <input
                className="w-full p-2 mb-3 border border-graycolor-500 outline-none rounded
                focus:bg-indigo-200 font-medium h-11"
                id="email"
                name="email"
                type="text"
                placeholder="Enter Your Email Id"
                autoComplete=""
                ref={register({
                  required: "You must Enter the Email",
                })}
              />
            </div>
            {errors.email && (
                  <p className='text-xs md:text-sm md:pb-4 text-hlred'>
                    {errors.email?.message}
                  </p>
                )}
            <div>
              <button
                type="submit"
                className="p-2 rounded font-medium h-11 text-white w-full bg-secondary bg-login_btn mb-3 shadow-md"
                aria-label="Change Password"
              >
                CHANGE PASSWORD
              </button>
            </div>
          </form>

          <Link
            to="/"
            className="mt-2 tracking-wider block text-fogotpwsd_login hover:text-fogotpwsd_login text-sm text-center font-semibold transition duration-700 ease-in-out underline"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ForgotPassword)
);
